import { login, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  account_id: null,
  first_name: null,
  last_name: null,
  email: null,
  site_id: null,
  role: null,
  rules: [],
  password_expire: null
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_ACCOUNT_ID: (state, accountId) => {
    state.account_id = accountId
  },
  SET_FIRST_NAME: (state, first_name) => {
    state.first_name = first_name
  },
  SET_LAST_NAME: (state, last_name) => {
    state.last_name = last_name
  },
  SET_EMAIL: (state, email) => {
    state.email = email
  },
  SET_ROLE: (state, role) => {
    state.role = role
  },
  SET_RULES: (state, rules) => {
    state.rules = rules
  },
  SET_SITE_ID: (state, site_id) => {
    state.site_id = site_id
  },
  SET_PASSWORD_EXPIRE: (state, password_expire) => {
    state.password_expire = password_expire
  }
}

const actions = {
  // user login
  login ({ commit }, userInfo) {
    const { username, password } = userInfo

    return new Promise((resolve, reject) => {
      login({ username, password }).then(
        response => {
          if (response.account.role === 'Provider') {
            reject(Error('Provider role is not allowed to frontend!'))
            return
          }
          commit('SET_TOKEN', response.token)
          commit('SET_ACCOUNT_ID', response.account_id)
          commit('SET_ROLE', response.account.role)
          commit('SET_SITE_ID', response.account.site_id)
          commit('SET_PASSWORD_EXPIRE', response.account.password_expire)
          setToken(response.token)
          resolve(response)
        }
      ).catch(error => {
        reject(error)
      })
    })
  },

  // set token manually
  setToken ({commit}, token) {
    commit('SET_TOKEN', token)
    setToken(token)
    return new Promise((resolve, reject) => {
      getInfo().then(data => {
        if (!data) {
          reject(Error('Verification failed, please Login again.'))
        }

        commit('SET_FIRST_NAME', data.account.first_name)
        commit('SET_LAST_NAME', data.account.last_name)
        commit('SET_EMAIL', data.account.email)
        commit('SET_ROLE', data.account.role)
        commit('SET_SITE_ID', data.account.site_id)
        commit('SET_RULES', data.rules)
        commit('SET_PASSWORD_EXPIRE', data.account.password_expire)

        resolve(data)
      }).catch(error => {
        reject('REJECT ' + error)
      })
    })    
  },
  // get user info
  getInfo (context) {
    return new Promise((resolve, reject) => {
      getInfo().then(data => {
        if (!data) {
          reject(Error('Verification failed, please Login again.'))
        }

        context.commit('SET_ACCOUNT_ID', data.account_id)
        context.commit('SET_FIRST_NAME', data.account.first_name)
        context.commit('SET_LAST_NAME', data.account.last_name)
        context.commit('SET_EMAIL', data.account.email)
        context.commit('SET_ROLE', data.account.role)
        context.commit('SET_SITE_ID', data.account.site_id)
        context.commit('SET_RULES', data.rules)

        const today = new Date();
        const passExpireDate = new Date(data.account.password_expire)

        if( today > passExpireDate) {
          context.dispatch("app/openChangePassword", {title:'Your password is expired! Please change it.', force:true}, {root:true})
        }

        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout ({ commit, state }) {
    return new Promise((resolve) => {
      logout(state.token).finally(() => {
        commit('SET_TOKEN', null)
        commit('SET_FIRST_NAME', null)
        commit('SET_LAST_NAME', null)
        commit('SET_EMAIL', null)
        commit('SET_ROLE', null)
        commit('SET_PASSWORD_EXPIRE', null)
        removeToken()
        resolve()
      })
      // resetRouter()
    })
  },

  // remove token
  resetToken ({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', null)
      commit('SET_FIRST_NAME', null)
      commit('SET_LAST_NAME', null)
      commit('SET_EMAIL', null)
      commit('SET_ROLE', null)
      commit('SET_PASSWORD_EXPIRE', null)
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
